import React, {useState, useEffect} from 'react';
import {hostUrl, tokenExpiredLoginAgain, siteUrl } from '../../constants/global';
import { useSelector, useDispatch } from 'react-redux';
import allActions from '../../actions/index';
import {useNavigate} from "react-router-dom";

const LoadData = () => {

    const topicBucketState =  useSelector(state => state.TopicBucket);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
  
        if(topicBucketState.datatrack===1){
                /******get data from localstorage*******/
                let authlogin = localStorage.getItem('authlogin');
                let storageData = authlogin ? JSON.parse(authlogin) : "";
                
                var token = 'Bearer '+storageData.token;
                var username = storageData.user_email;
          
                const data = { callingaction: 'topic_list' };
  
                const requestOptions = {
                        method: 'POST',
                        //mode:'cors',
                        headers: { 'Content-Type': 'application/json', 
                        'POST' : '/resource HTTP/1.1',
                        'Authorization': token,
                        'Host' : hostUrl,
                        'username' : username,
                        body: JSON.stringify(data),
                        }
                    };
  
                fetch(siteUrl+'/community-rest-functions.php?action=topic_handle',requestOptions)
                .then((response) => response.json())
                .then(function(actualData){ 
                    console.log(actualData);
                    if(actualData.status=='success'){
                      dispatch( allActions.TopicData.setTopicData(actualData));
                    }else if(actualData.status=='validationerror'){
                      dispatch( allActions.ModalPopup.showPopup({ popupname:'alertbox', title: tokenExpiredLoginAgain}));
                      //alert(tokenExpiredLoginAgain);
                      navigate('/login/?message='+tokenExpiredLoginAgain);
                    }
                    //setResponseMessage({status:"success",message:"We have send the topic for approval"});
                
                }).catch(rejected => {
                    //setResponseMessage({status:"error",message:highTrafficInnerPages});
                });
  
            }
  
            /*******add class on body*****/
            // document.body.classList.add('white-bg-header');
            // return () => {
            //   document.body.classList.remove('white-bg-header');
            // }
  
      },[]);

  return (<></>)
}

export default LoadData;